import Cookies from "js-cookie";

const TokenKey = "token";
const CookieKey = "JSESSIONID";
const storge = sessionStorage;

export function getToken() {
  // return this.$auth.getToken();
  return storge.getItem(TokenKey);
}

export function removeToken() {
  // return this.$auth.removeToken();

  return storge.removeItem(TokenKey);
}
export function removeCookie() {
  return Cookies.remove(CookieKey);
}

export function setCookie(ticket) {
  return Cookies.set("JSESSIONID", ticket);
}

export function getCookie() {
  return Cookies.get("JSESSIONID");
}
